import React from "react";
import { Button, Form, Spinner, Table } from "react-bootstrap";
import { money } from "../BudgetPage.utils";

const BudgetSummaryTable = ({
  loading,
  year,
  rows,
  filteredRows,
  error,
  search,
  onSearchChange,
  onEdit,
  onShowExpenses,
  canManageBudgets,
  getAgentName,
}) => (
  <>
    {error && (
      <div className="alert alert-danger" role="alert">
        {error}
      </div>
    )}
    {!loading && rows.length > 0 && (
      <Form.Group className="mb-4">
        <Form.Label>Filtra tabella per agente, mese o importo</Form.Label>
        <Form.Control
          type="search"
          value={search}
          onChange={onSearchChange}
          placeholder="Es. Rossi, maggio o 1.250,00"
          aria-label="Filtra tabella Budget per agente, mese o importo"
        />
        <Form.Text className="text-muted">
          {filteredRows.length} risultati su {rows.length}
        </Form.Text>
      </Form.Group>
    )}
    {loading ? (
      <div className="text-center py-10">
        <Spinner animation="border" role="status" />
        <div className="text-muted mt-3">Caricamento budget…</div>
      </div>
    ) : rows.length === 0 ? (
      <div className="text-center text-muted py-10">Nessun budget registrato per {year}.</div>
    ) : filteredRows.length === 0 ? (
      <div className="text-center text-muted py-10">Nessun agente o importo corrisponde al filtro.</div>
    ) : (
      <Table responsive hover className="mb-0">
        <thead>
          <tr>
            <th>Agente</th>
            <th>Anno</th>
            <th>Budget</th>
            <th>Speso</th>
            <th>Disponibile</th>
            <th>Utilizzo</th>
            <th className="text-right">Azioni</th>
          </tr>
        </thead>
        <tbody>
          {filteredRows.map((row) => {
            const budget = Number(row.importo || 0);
            const spent = Number(row.spese || 0);
            const remaining = budget - spent;
            const overBudget = spent > budget;
            const percent = budget > 0 ? Math.round((spent / budget) * 100) : spent > 0 ? 100 : 0;
            const barColor = overBudget ? "bg-danger" : percent >= 80 ? "bg-warning" : "bg-success";

            return (
              <tr key={String(row.idAgente) + "-" + String(row.anno)}>
                <td className="font-weight-bold">{getAgentName(row.idAgente)}</td>
                <td>{row.anno}</td>
                <td>
                  {money(budget)}
                  {!row.exists && <span className="d-block small text-warning">Da impostare</span>}
                </td>
                <td>{money(spent)}</td>
                <td className={overBudget ? "text-danger font-weight-bold" : "text-success"}>
                  {money(remaining)}
                  {overBudget && <span className="d-block small">Fuori budget</span>}
                </td>
                <td style={{ minWidth: 150 }}>
                  <div className="d-flex justify-content-between small mb-1">
                    <span>{percent}%</span>
                    {overBudget && <span className="text-danger">Sforato</span>}
                  </div>
                  <div className="progress" style={{ height: 7 }}>
                    <div
                      className={`progress-bar ${barColor}`}
                      role="progressbar"
                      style={{ width: Math.min(percent, 100) + "%" }}
                      aria-valuenow={percent}
                      aria-valuemin="0"
                      aria-valuemax="100"
                    />
                  </div>
                </td>
                <td className="text-right text-nowrap">
                  {canManageBudgets && (
                    <Button size="sm" variant="light-primary" className="mr-2" onClick={() => onEdit(row)}>
                      Modifica budget
                    </Button>
                  )}
                  <Button size="sm" variant="light" onClick={() => onShowExpenses(row)}>
                    Dettaglio spese
                  </Button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    )}
  </>
);

export default BudgetSummaryTable;
